import ScaleToFit from "./ScaleToFit";
import ManualAnnotationGridTable from './ManualAnnotationGridTable';
import { useState, useEffect, useRef } from 'react';
import G from './Getters';
import C from './Constants';
import A from './ActionCreators';
import EditIcon from '@material-ui/icons/Edit';
import TransformedPreviewPanel from './TransformedPreviewPanel';

import EditableContent from './EditableContent';
import { FIGURE_PANELS } from './RecordTypes';

import { useDispatch, useSelector } from 'react-redux';

export default function PanelPreview({
  figurePanelId, 
  editable,
  maxDimensions, 
}){

  let content = (
    <ManualAnnotationGridTable editable={false} tableOutlineShowing={false} figurePanelId={figurePanelId}/>
  )

  return (

    <div style={{
      position:'relative',
      
      //background:'#fdfdfd',
      opacity: 1,// (renderedDim ? 1 : 0),
    }}>
      <div
        class="hoverable"
        style={{
          borderRadius: "6px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          paddingTop:5,

          //border:'1px solid #ccc',
          background:'white',
          maxWidth:maxDimensions[0],
          //maxHeight:maxDimensions[1],
          pointerEvents:'none',
          //border:'3px solid red',
        }}>
        <ScaleToFit dimensions={maxDimensions}>
          {content}
        </ScaleToFit>
      </div>
    </div>

  )
}
